import React,{Component} from 'react'

// import {
//   Label,
//   Legend,
//   RadialBarChart,
//   RadialBar,
//   Tooltip,
// } from 'recharts'

import {
  PieChart,
  Pie,
  // Sector,
  Cell,
  Tooltip,
  Legend,
} from 'recharts'
import UnauthorizedText from './UnauthorizedText'
import {
  Accent,
  Primary,
  Purple,
  Green,
  LightGray,
} from '../helper/consts'

import '../styles/Dashboard.css'

const colors = [Primary,Accent,Purple,Green,LightGray,]

// const data = [
//   {name: '18-24', uv: 31.47, pv: 2400, fill: '#8884d8'},
//   {name: '25-29', uv: 26.69, pv: 4567, fill: '#83a6ed'},
//   {name: '30-34', uv: 15.69, pv: 1398, fill: '#8dd1e1'},
//   {name: '35-39', uv: 8.22, pv: 9800, fill: '#82ca9d'},
//   {name: '40-49', uv: 8.63, pv: 3908, fill: '#a4de6c'},
//   {name: '50+', uv: 2.63, pv: 4800, fill: '#d0ed57'},
//   {name: 'unknow', uv: 6.67, pv: 4800, fill: '#ffc658'}
// ];

export default class AdminJobSummaryEndorsementsPieChart extends Component{
  render(){
    const {job} = this.props;
    let endorsements = {};
    endorsements = job.endorsements || {};
    let formatted = [];
    let one = 0;
    let two = 0;
    let three = 0;
    let four = 0;
    let five = 0;
    for (let user in endorsements){
      let usersEndorsements = endorsements[user];
      for(let endorsement in usersEndorsements){
        let item = usersEndorsements[endorsement]
        if(item.rating===1){one++}
        if(item.rating===2){two++}
        if(item.rating===3){three++}
        if(item.rating===4){four++}
        if(item.rating===5){five++}
      }
    }
    five>0&&formatted.push({[`name`]: `5⭐️s`,[`value`]: five,fill: colors[0],})
    four>0&&formatted.push({[`name`]: `4⭐️s`,[`value`]: four,fill: colors[1],})
    three>0&&formatted.push({[`name`]: `3⭐️s`,[`value`]: three,fill: colors[2],})
    two>0&&formatted.push({[`name`]: `2⭐️s`,[`value`]: two,fill: colors[3],})
    one>0&&formatted.push({[`name`]: `1⭐️`,[`value`]: one,fill: colors[4],})
    return(
      formatted.length===0?
        <div className="noData">
          <UnauthorizedText subText='Not Enough Data' />
        </div>
      :
        <PieChart
          width={300}
          height={300}
        >
          <Pie
            data={formatted}
            dataKey="value"
            nameKey="name"
            innerRadius={50}
            outerRadius={80}
            fill="#8884d8"
            paddingAngle={1}
          >
            {
              formatted.map((entry, index) => <Cell key={index} fill={colors[index]}/>)
            }
          </Pie>
          <Tooltip/>
          <Legend />
       </PieChart>
    )
  }
}
// wrapperStyle={style}



// WEBPACK FOOTER //
// ./src/components/AdminJobSummaryEndorsementsPieChart.js